// hooks/useProductsLoader.js
import { useEffect, useContext, useState } from "react";
import { Context } from "../index"; // путь подкорректируй под свой
import { getFavoriteProductsParent, getWholesalePrices } from "../http/productAPI";

export const useFavoriteProductsLoader = () => {
  const { product, user } = useContext(Context);

  useEffect(() => {
    const loadFavoriteProducts = async () => {
      // console.log ("useEffect loadFavoriteProducts")
      try {
      
      //  if (!filtersFromURLLoaded) return;    // запустить эту проверку перед прогрузкой где нужны ссылки 
        const allFavorites = await getFavoriteProductsParent(product.selectedFolder.id)
      
        let updatedProducts = allFavorites;
                  
        if (user.viewAsManager && updatedProducts.length > 0) {

          const productIds = updatedProducts.map((p) => p.id);

          const optPrices = await getWholesalePrices(productIds);

          updatedProducts = updatedProducts.map((p) => ({
            ...p,
            optPrice: optPrices.find((w) => w.id === p.id)?.optPrice ?? 0
          }));
        }

        product.setProducts(updatedProducts);
      //  product.setFilters(data.filters);

      } catch (error) {
        console.error("Ошибка при получении продуктов:", error);
      }
    };

    loadFavoriteProducts();
  }, [
    product.selectedFolder,
    product.reload,
    user.viewAsManager
  ]);
};
